export const MINIO_URL = process.env.MINIO_URL || "/images/";
export const API_BASE_URL = process.env.API_BASE_URL || "https://api.medrickian.com/api";
export const MONTHS = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

export const fetchGameData = async (params = {}) => {
    try {
        const { game_id } = params;
        let url = `${API_BASE_URL}/games/`
        if (game_id !== undefined) url += game_id;
        const response = await fetch(url);

        if (!response.ok) {
            throw new Error(`Failed to fetch games: ${response.status}`);
        }

        return await response.json();

    } catch (error) {
        console.error('Error fetching game data:', error);
        throw error;
    }
};